// ============================================================
// Die Schale um alles, was KEINE Karte ist: Board, Abgaben, Team, Büro,
// Profil, Verwaltung.
//
// Sie liefert drei Dinge und sonst nichts:
//   1. die schwebende Kopfleiste,
//   2. den Freiraum darunter und über der Reiterleiste (`.schale`),
//   3. die Reiterleiste selbst (blendet sich am Schreibtisch aus).
//
// Der INHALT bringt seine eigene Breite mit — F4 mit `.an`, meine Bildschirme
// mit `.blatt`. Deshalb setzt `.schale` nur den vertikalen Abstand: sonst
// stünden die Seitenränder zweimal da und der Abstand wäre doppelt so groß
// wie in der Entwurfsmappe.
//
// Die KARTE benutzt diese Schale NICHT. Sie füllt den ganzen Schirm, zeichnet
// <TopNav /> und <MobilLeiste /> selbst (F2) und legt ihre Tafeln als
// schwebende Glasflächen darüber.
// ============================================================
import { Outlet } from "react-router-dom";
import { MobilLeiste } from "./MobilLeiste";
import { TopNav } from "./TopNav";

export function Shell() {
  return (
    <>
      <TopNav />
      <div className="schale">
        <Outlet />
      </div>
      <MobilLeiste />
    </>
  );
}
